export const TAB_INBOX = "inbox";
export const TAB_UNREAD = "unread";
export const TAB_AGENTS = "agents";

/**
 * Build the ordered list of visible tab values based on feature flags.
 * Shared between TabHeaderV4 (desktop) and MessagesContent (mobile).
 */
export const getMessageTabValues = (
  shouldShowMessagesTab: boolean,
  shouldShowAgentsTab: boolean,
): string[] => {
  const values: string[] = [];
  if (shouldShowMessagesTab) {
    values.push(TAB_INBOX, TAB_UNREAD);
  }
  if (shouldShowAgentsTab) {
    values.push(TAB_AGENTS);
  }
  return values;
};
